import React, {Fragment, Suspense} from 'react';
import './assets/legacy.css';
import LegacyFrame from "./LegacyFrame";
import {capitalize, getSessionValue, setSessionValue} from "../../Common/Appcommon";

class LegacyCustomForms extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let formLabel = "";
        let formname = "";
        let formId = "";
        if(this.props.match !== undefined && this.props.match.params.formlabel !== undefined){
            formLabel = this.props.match.params.formlabel;
            formLabel = formLabel.replace("_", " ")
        }
        if(this.props.match !== undefined && this.props.match.params.formId !== undefined){
            formId = this.props.match.params.formId;
            setSessionValue("currentmenu", "");
            //setSessionValue("currentmenu", formLabel);
        }
        let labelMapper = getSessionValue('formlabelnNameMapper');
        if(labelMapper == ""){
            return <></>
        } else {
            labelMapper = JSON.parse(labelMapper);
            formname = labelMapper[formLabel];
            if(formname === undefined){
                return <></>
            }
        }
        let label = capitalize(formLabel);
        return (
            <LegacyFrame withHeader={true} pageTitle={label} formId={formId} formname={formname} customClass={"field-customization-container"} />
        );
    }
}

export default LegacyCustomForms;
